var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex" }, [
    _c(
      "div",
      {
        staticClass: "milestone-left d-flex flex-row position-relative",
        style: { width: "130px" },
      },
      [
        _c(
          "div",
          {
            staticClass: "text-xl-caption ms-1",
            staticStyle: {
              width: "65px",
              display: "flex",
              "flex-direction": "column",
              height: "100%",
            },
          },
          [
            _vm.isFirst
              ? _c("div", { staticClass: "white-space-pre" }, [
                  _vm._v("スタート"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "font-bold" }, [
              _vm._v(_vm._s(_vm.dateFormat(_vm.milestone.startDate))),
            ]),
            _vm._v(" "),
            _vm.isLast
              ? _c(
                  "div",
                  {
                    staticClass: "font-bold",
                    staticStyle: { "margin-top": "auto" },
                  },
                  [_vm._v(_vm._s(_vm.dateFormat(_vm.milestone.targetDate)))]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ms-2 justify-space-between position-relative" },
          [
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c(
                "span",
                {
                  staticClass:
                    "dot-circle d-flex justify-content-center align-center",
                  class: _vm.progressPercent > 0 ? "dot-blue" : "dot-gray",
                },
                [
                  _vm.milestone.completedAt
                    ? _c("v-icon", { attrs: { color: "white", small: "" } }, [
                        _vm._v("mdi-check"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center w-full position-absolute",
                style: { height: _vm.isLast ? "calc(100% - 30px)" : "100%" },
              },
              [
                _c("div", { staticClass: "dot-line" }, [
                  _c("div", {
                    staticClass: "dot-line-blue w-full",
                    style: { height: _vm.progressPercent + "%" },
                  }),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.isLast
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-center position-absolute",
                    staticStyle: { bottom: "1px" },
                  },
                  [
                    _c("span", {
                      staticClass:
                        "dot-circle last-dot d-flex justify-content-center align-center",
                      class:
                        _vm.progressPercent == 100 ? "dot-blue" : "dot-gray",
                    }),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ps-3 pb-4", style: { width: "calc(100% - 130px)" } },
      [
        _c(
          "div",
          {
            ref: "mileston-toggle",
            staticClass: "d-flex justify-space-between cursor-pointer",
            attrs: {
              "data-bs-toggle": "collapse",
              "data-bs-target": "#collapse" + _vm.milestone.id,
              "aria-expanded": "false",
              "aria-controls": "collapse" + _vm.milestone.id,
            },
          },
          [
            _c("div", { staticClass: "d-flex fs-6 fw-bold" }, [
              _c("span", [_vm._v(" " + _vm._s(_vm.milestone.name) + " ")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-center text-gray fs-6 fw-bold" },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.progressPercent) + "%\n        "
                ),
                _c("v-icon", { staticClass: "ms-2" }, [
                  _vm._v("mdi-arrow-down-drop-circle-outline"),
                ]),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("v-divider"),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "collapse",
              attrs: { id: "collapse" + _vm.milestone.id },
            },
            [
              _vm._l(_vm.milestone.enrollments, function (enrollment) {
                return _c(
                  "div",
                  {
                    key: enrollment.id,
                    staticClass: "d-flex justify-space-between mt-4",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("v-icon", { attrs: { color: "blue" } }, [
                          _vm._v(
                            _vm._s(
                              enrollment.progressPercent == 100
                                ? "mdi-checkbox-marked-outline"
                                : "mdi-checkbox-blank-outline"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        !_vm.mobile
                          ? _c(
                              "div",
                              { staticClass: "ms-6" },
                              [
                                _c("v-img", {
                                  attrs: {
                                    src: enrollment.course.image.url,
                                    "max-height": "50",
                                    "min-height": "50",
                                    "max-width": "60",
                                    "min-width": "60",
                                    contain: "",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "ms-8 d-flex align-center text-blue2 cursor-pointer",
                            on: {
                              click: function ($event) {
                                _vm.saveGoalAndNavigate(
                                  enrollment.course.id.toString()
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(enrollment.course.name) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ps-2 d-flex align-center text-gray" },
                      [_vm._v(_vm._s(enrollment.progressPercent) + "%")]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.milestone.exams, function (exam) {
                return _c(
                  "div",
                  {
                    key: exam.id,
                    staticClass: "d-flex justify-space-between mt-4",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("v-icon", { attrs: { color: "blue" } }, [
                          _vm._v(
                            _vm._s(
                              exam.hasUserExam && exam.userExamScore != null
                                ? "mdi-checkbox-marked-outline"
                                : "mdi-checkbox-blank-outline"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        !_vm.mobile
                          ? _c(
                              "div",
                              { staticClass: "ms-6" },
                              [
                                _c("v-img", {
                                  attrs: {
                                    src: exam.image.url,
                                    "max-height": "50",
                                    "min-height": "50",
                                    "max-width": "60",
                                    "min-width": "60",
                                    contain: "",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "ms-8 d-flex align-center text-blue2 cursor-pointer",
                            on: {
                              click: function ($event) {
                                _vm.toExam(exam.id.toString())
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(exam.name) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex ps-2 align-center text-gray" },
                      [
                        !exam.hasUserExam
                          ? [_vm._v("\n              テスト待ち\n            ")]
                          : exam.userExamScore !== null
                          ? [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    exam.hideResult
                                      ? "結果公開待ち"
                                      : exam.userExamScore + "点"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          : [_vm._v("\n              テスト中\n            ")],
                      ],
                      2
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }